// src/lib/strapi.js
const API_URL = process.env.REACT_APP_STRAPI_URL; // e.g. https://cms.zerotyping.ai
const API_BASE = `${API_URL}/api`;
const API_TOKEN = process.env.REACT_APP_STRAPI_TOKEN || ""; // optional

const authHeaders = API_TOKEN ? { Authorization: `Bearer ${API_TOKEN}` } : {};

export const buildImageUrl = (file) => {
  if (!file) return "";
  const url = file.url || file?.formats?.large?.url || file?.formats?.medium?.url || file?.formats?.small?.url;
  if (!url) return "";
  return url.startsWith("http") ? url : `${API_URL}${url}`;
};

// Small helper to accept string | string[] for populate
const normalizePopulate = (populate) => {
  if (!populate) return "*";
  if (Array.isArray(populate)) return populate.join(",");
  if (typeof populate === "string") return populate;
  // fallback
  return "*";
};

const baseFetch = async (path, params = {}) => {
  const url = new URL(`${API_BASE}${path}`);

  // normalize populate
  if (params.populate !== undefined) {
    params.populate = normalizePopulate(params.populate);
  } else {
    params.populate = "*"; // default deep populate to avoid 400s
  }

  url.search = new URLSearchParams(params).toString();

  const res = await fetch(url.toString(), { headers: { ...authHeaders } });
  if (!res.ok) {
    // bubble up the body so you can see why it failed (400 details)
    let detail = "";
    try {
      const txt = await res.text();
      detail = txt;
    } catch {}
    throw new Error(`Strapi error ${res.status} ${res.statusText}: ${detail}`);
  }
  return res.json();
};

// LIST — /api/articles
export const getArticles = async ({
  page = 1,
  pageSize = 9,
  categorySlug = "",
  search = "",
  populate = "*",
} = {}) => {
  const params = {
    "pagination[page]": page,
    "pagination[pageSize]": pageSize,
    sort: "publishedAt:desc",
    populate,
  };

  if (categorySlug) {
    params["filters[category][slug][$eq]"] = categorySlug;
  }
  if (search) {
    params["filters[$or][0][title][$containsi]"] = search;
    params["filters[$or][1][description][$containsi]"] = search;
  }

  return baseFetch("/articles", params);
};

// SINGLE by slug — /api/articles?filters[slug][$eq]=...
export const getArticleBySlug = async (slug, { populate = "*" } = {}) => {
  const params = {
    "filters[slug][$eq]": slug,
    populate,
  };
  const data = await baseFetch("/articles", params);
  return data?.data?.[0] || null;
};

// CATEGORIES (optional)
export const getCategories = async () => {
  try {
    const data = await baseFetch("/categories", { "pagination[pageSize]": 100 });
    return data?.data || [];
  } catch {
    return [];
  }
};
